import { Injectable } from '@angular/core';

import { KeyValuePair } from '@reg/shared/model';

/**
 * Service for getting the type of registrations (None, Online, Onsite, Online & Onsite)
 */
@Injectable()
export class RegistrationTypeService {
    // Consts are a copy of the RegistrationType enum defined in the floarena-api
    public static NONE: string = 'none';
    public static ONLINE_ONLY: string = 'online-only';
    public static INVITE_ONLY: string = 'invite-only';
    public static ONSITE_ONLY: string = 'onsite-only';
    public static ONSITE_ONLINE: string = 'onsite-online';

    private types: KeyValuePair[] = [];

    /**
     * Constructor. Build enum list
     */
    constructor() {
        this.types.push(new KeyValuePair(RegistrationTypeService.NONE, 'None'));
        this.types.push(new KeyValuePair(RegistrationTypeService.ONLINE_ONLY, 'Online Only'));
        this.types.push(new KeyValuePair(RegistrationTypeService.ONSITE_ONLY, 'Onsite Only'));
        this.types.push(new KeyValuePair(RegistrationTypeService.ONSITE_ONLINE, 'Onsite & Online'));
        this.types.push(new KeyValuePair(RegistrationTypeService.INVITE_ONLY, 'Team Invite'));
    }

    /**
     * Get all types of registration
     */
    public getIndex(): KeyValuePair[] {
        return this.types;
    }

    /**
     * Get a single registration type
     */
    public get(key: string): KeyValuePair {
        const foundTypes: KeyValuePair[] = this.types.filter((type: KeyValuePair) => type.key === key);

        if (foundTypes && foundTypes.length > 0) {
            // Found a match
            return foundTypes[0];
        }

        // No match found so construct a new one
        return new KeyValuePair(key, key);
    }
}
